import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var PhotoshopShortcutSvg = function PhotoshopShortcutSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#001E36",
    fillRule: "evenodd",
    d: "M2 0h20a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2H8.708A9 9 0 0 0 0 9.223V2a2 2 0 0 1 2-2",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31A8FF",
    fillRule: "evenodd",
    d: "M9.673 13.294c1.789-.217 2.94-1.348 2.94-3.147 0-2.121-1.631-3.27-3.815-3.27H5.207v2.71c.605.232 1.18.527 1.715.877V8.221H8.93c1.183 0 2.065.665 2.065 1.827 0 1.14-.834 1.918-2.016 1.918h-.301q.556.616.994 1.327m9.757 1.627c0 1.4-1.14 2.219-2.925 2.219-1.512 0-2.905-.7-3.143-2.338h1.498c.189.805.91 1.134 1.637 1.134.869 0 1.45-.294 1.45-.917 0-.455-.28-.714-.938-.854l-1.373-.315c-1.231-.273-2.03-.854-2.036-1.995-.008-1.288.994-2.233 2.905-2.233 1.687 0 2.786.777 2.82 2.17h-1.448c-.105-.623-.61-.994-1.386-.994-.806 0-1.373.308-1.373.938 0 .44.386.672 1.176.84l1.302.315c1.485.37 1.834 1.35 1.834 2.03",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.313 23.583q-1.793 0-3.053-1.245T0 19.295q0-1.27.647-2.288a4.36 4.36 0 0 1 1.725-1.57H0V14h5.39v5.39H3.954v-2.97a2.72 2.72 0 0 0-1.797.934 2.8 2.8 0 0 0-.719 1.917q0 1.201.839 2.038a2.78 2.78 0 0 0 2.037.837z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};
export var PhotoshopShortcut = function PhotoshopShortcut(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: PhotoshopShortcutSvg
  }));
};